/**
 * Working hours for phone support in different countries
 */
export const HELP_CENTER_PHONE_WORKING_HOURS =
  'HELP_CENTER_PHONE_WORKING_HOURS';
